
import { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
} from "@gpstrackit/react-controls";

import { JsonView, allExpanded, darkStyles, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';

import { copyToClipboard } from 'Core/data/Helpers';
//Actions
import {
    clearRedux,
} from 'Redux/actions';

const RawMessageView = (props) => {

    const { messages } = useIntl();
    const dispatch = useDispatch();

    const [currentData, setCurrentData] = useState(null)

    //Redux States
    const { details, openModal, title, isHtml, html } = useSelector(state => state.rawMessageViewRedux)

    const closeModal = () => {
        dispatch(clearRedux("RAW_MESSAGE_VIEW"));
        setCurrentData(null);
    }

    useEffect(() => {
        if (openModal && details) {
            /* let newResult
            try {
                newResult = JSON.stringify(details, undefined, 2)
            } catch (error) { } */
            setCurrentData(details)
        }
    }, [openModal])

    return (
        <Modal
            open={openModal}
            title={title ? title : messages['devices_main_device_raw_data']}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={false}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 30 }}>


                    {
                        !isHtml && currentData &&
                        <JsonView data={currentData} shouldExpandNode={allExpanded} style={defaultStyles} /> || <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', marginTop: 10, opacity: 0.5 }}>{messages['common_no_information_to_display']}</div>
                    }

                    {
                        isHtml &&
                        <div dangerouslySetInnerHTML={{ __html: html }} />
                    }
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={(e) => {
                        copyToClipboard(JSON.stringify(currentData), messages['common_copied'])
                    }}
                >
                    {messages['show_raw_data_modal_copy']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => closeModal()}
                >
                    {messages['close']}
                </Button>
            </ModalFooter>
        </Modal >
    )
}

export default RawMessageView;